module.exports = __webpack_public_path__ + "img/571.9500fe1e.jpg";